var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_775",
    "data-name": "Group 775",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_948",
    "data-name": "Rectangle 948",
    width: 40,
    height: 30,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_774",
    "data-name": "Group 774",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M35,0H5A5,5,0,0,0,0,5V25a5,5,0,0,0,5,5H35a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5",
    fill: "#0f4ca1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M16.75,19.688h2.813V15.046a3.042,3.042,0,0,0,2.749,1.394c2.484,0,3.814-2.1,3.814-4.626,0-2.066-1.265-4.314-3.573-4.314a3.1,3.1,0,0,0-2.99,1.739V7.5H16.75Zm6.395-7.808c0,1.361-.657,2.3-1.746,2.3a1.988,1.988,0,0,1-1.764-2.181c0-1.28.7-2.231,1.764-2.231,1.121,0,1.746.984,1.746,2.116",
    transform: "translate(4.188 1.875)",
    fill: "#fffffe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M17.125,7.694H14.476V9.21h-.031A3.312,3.312,0,0,0,11.569,7.5C8.936,7.5,7.75,9.373,7.75,11.875c0,2.486,1.446,4.228,3.77,4.228a3.3,3.3,0,0,0,2.842-1.435H14.4v.451c0,1.648-.91,2.438-2.6,2.438a5.858,5.858,0,0,1-2.86-.692L8.79,19.155a9.942,9.942,0,0,0,3.234.533c3.413,0,5.1-1.115,5.1-4.569Zm-6.352,4.131c0-1.146.569-2.1,1.658-2.1A1.844,1.844,0,0,1,14.3,11.714a1.969,1.969,0,0,1-1.869,2.162c-.878,0-1.658-.742-1.658-2.051",
    transform: "translate(1.938 1.875)",
    fill: "#fffffe",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGp);
export default __webpack_public_path__ + "static/media/gp.15c5e31f7b5007fe2a928d7e3410a964.svg";
export { ForwardRef as ReactComponent };